<template>
  <div class="no-data">
    <img :src="imgUrl" alt="暂无数据" />
    <p class="text">暂无数据</p>
  </div>
</template>

<script>
export default {
  computed: {
    imgUrl() {
      return `${process.env.BASE_URL || "./"}file/no-data.png`;
    }
  }
};
</script>

<style lang="scss">
.no-data {
  width: 50%;
  margin: 20px auto;
  text-align: center;

  img {
    width: 100%;
    opacity: 0.4;
  }

  .text {
    font-size: 20px;
    color: #ccc;
    font-weight: lighter;
  }
}
</style>
